import * as z from "zod/v4";

const employeeSchema = z.object({
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  department: z.string(),
});

export const searchEmployees = {
  name: "searchEmployees" as const,
  input: z.object({
    query: z.string().min(1),
    limit: z.number().min(1).max(50).default(10),
  }),
  output: z.object({ employees: z.array(employeeSchema) }),
};

export type Employee = z.infer<typeof employeeSchema>;
export type SearchEmployeesInput = z.infer<typeof searchEmployees.input>;
export type SearchEmployeesOutput = z.infer<typeof searchEmployees.output>;
